import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-185">
      <div className="max-w-[860px] mx-auto" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-187">
          <h2 className="text-[32px] font-bold text-dark mb-3" data-id="element-188">
            El Sistema de 3 Ejes que Revierte el Bloqueo Metabólico Después de
            los 40
          </h2>
          <p className="text-[17px] text-[#555]" data-id="element-189">
            No es otra dieta. Es hackear tu sistema hormonal desde adentro.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-190">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-teal rounded-2xl p-8 shadow-[0_4px_20px_rgba(0,0,0,0.08)] flex flex-col" data-id="element-191">
            <div className="flex flex-col items-center mb-6" data-id="element-192">
              <div className="w-14 h-14 bg-teal/10 rounded-full flex items-center justify-center text-3xl mb-3" data-id="element-193">
                🔑
              </div>
              <span className="bg-teal text-white text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-194">
                EJE 1
              </span>
              <h3 className="text-[22px] font-bold text-teal text-center" data-id="element-195">
                La Insulina
              </h3>
            </div>

            <div className="bg-teal/10 rounded-lg p-4 mb-4" data-id="element-196">
              <p className="text-[15px] italic text-teal text-center font-medium" data-id="element-197">
                "Reduce el pico de insulina hasta un 75% sin cambiar ni una
                caloría de tu plato"
              </p>
            </div>

            <p className="text-[15px] text-[#555] mb-6 flex-grow text-center" data-id="element-198">
              Cambiar el ORDEN en que comes (fibra → proteína → grasa →
              carbohidrato) transforma tu respuesta hormonal completamente.
            </p>

            <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-199">
              <div className="flex flex-col gap-2 text-sm font-medium" data-id="element-200">
                <div className="bg-green-100 text-green-800 px-3 py-1.5 rounded text-center" data-id="element-201">
                  Fibra 🥗
                </div>
                <div className="text-center text-gray-400 text-xs" data-id="element-202">↓</div>
                <div className="bg-red-100 text-red-800 px-3 py-1.5 rounded text-center" data-id="element-203">
                  Proteína 🥩
                </div>
                <div className="text-center text-gray-400 text-xs" data-id="element-204">↓</div>
                <div className="bg-yellow-100 text-yellow-800 px-3 py-1.5 rounded text-center" data-id="element-205">
                  Grasa 🥑
                </div>
                <div className="text-center text-gray-400 text-xs" data-id="element-206">↓</div>
                <div className="bg-orange-100 text-orange-800 px-3 py-1.5 rounded text-center" data-id="element-207">
                  Carbos 🌮
                </div>
              </div>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white border-2 border-orange rounded-2xl p-8 shadow-[0_4px_20px_rgba(0,0,0,0.08)] flex flex-col" data-id="element-208">
            <div className="flex flex-col items-center mb-6" data-id="element-209">
              <div className="w-14 h-14 bg-orange/10 rounded-full flex items-center justify-center text-3xl mb-3" data-id="element-210">
                🧘
              </div>
              <span className="bg-orange text-white text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-211">
                EJE 2
              </span>
              <h3 className="text-[22px] font-bold text-orange text-center" data-id="element-212">
                El Cortisol
              </h3>
            </div>

            <div className="bg-orange/10 rounded-lg p-4 mb-4" data-id="element-213">
              <p className="text-[15px] italic text-orange text-center font-medium" data-id="element-214">
                "2 minutos de respiración diafragmática activan el nervio vago y
                frenan la acumulación de grasa abdominal"
              </p>
            </div>

            <p className="text-[15px] text-[#555] mb-6 flex-grow text-center" data-id="element-215">
              El estrés crónico le dice a tu cuerpo que guarde grasa. Esta
              técnica lo detiene antes de que arruine tu metabolismo.
            </p>

            <div className="mt-auto pt-4 border-t border-gray-100 flex justify-center items-center" data-id="element-216">
              <div className="relative w-32 h-32 rounded-full border-4 border-dashed border-orange/30 flex items-center justify-center" data-id="element-217">
                <div className="text-center" data-id="element-218">
                  <div className="text-xs font-bold text-orange" data-id="element-219">INHALA 4</div>
                  <div className="text-[10px] text-gray-400 my-1" data-id="element-220">RETÉN 7</div>
                  <div className="text-xs font-bold text-orange" data-id="element-221">EXHALA 8</div>
                </div>
                {/* Decorative arcs */}
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" data-id="element-222">
                  <circle cx="50" cy="50" r="48" fill="none" stroke="#E8734A" strokeWidth="4" strokeDasharray="75 225" strokeLinecap="round" className="origin-center -rotate-90" data-id="element-223" />
                </svg>
              </div>
            </div>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white border-2 border-lime rounded-2xl p-8 shadow-[0_4px_20px_rgba(0,0,0,0.08)] flex flex-col" data-id="element-224">
            <div className="flex flex-col items-center mb-6" data-id="element-225">
              <div className="w-14 h-14 bg-lime/10 rounded-full flex items-center justify-center text-3xl mb-3" data-id="element-226">
                ⏰
              </div>
              <span className="bg-lime-dark text-white text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-227">
                EJE 3
              </span>
              <h3 className="text-[22px] font-bold text-lime-dark text-center" data-id="element-228">
                La Crononutrición
              </h3>
            </div>

            <div className="bg-lime/10 rounded-lg p-4 mb-4" data-id="element-229">
              <p className="text-[15px] italic text-lime-dark text-center font-medium" data-id="element-230">
                "Los mismos alimentos en el horario correcto producen resultados
                metabólicos completamente distintos"
              </p>
            </div>

            <p className="text-[15px] text-[#555] mb-6 flex-grow text-center" data-id="element-231">
              Tu metabolismo no es el mismo a las 7 AM que a las 7 PM. Comer en
              el momento correcto es tan importante como qué comes.
            </p>

            <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-232">
              <div className="relative pl-4 border-l-2 border-lime/30 space-y-4 py-2" data-id="element-233">
                <div className="relative" data-id="element-234">
                  <div className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-lime-dark" data-id="element-235"></div>
                  <span className="text-xs font-bold text-lime-dark block" data-id="element-236">
                    7:00 AM
                  </span>
                  <span className="text-sm text-gray-600" data-id="element-237">
                    Desayuno proteico
                  </span>
                </div>
                <div className="relative" data-id="element-238">
                  <div className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-lime-dark" data-id="element-239"></div>
                  <span className="text-xs font-bold text-lime-dark block" data-id="element-240">
                    1:00 PM
                  </span>
                  <span className="text-sm text-gray-600" data-id="element-241">Comida grande</span>
                </div>
                <div className="relative" data-id="element-242">
                  <div className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-lime-dark" data-id="element-243"></div>
                  <span className="text-xs font-bold text-lime-dark block" data-id="element-244">
                    7:00 PM
                  </span>
                  <span className="text-sm text-gray-600" data-id="element-245">Cena ligera</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}